import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-loader',
    templateUrl: './page-loader.component.html',
    styles: []
})
export class PageLoaderComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/lspcourier-dev/src/app/page-loader/page-loader.component.ts